import React from 'react';
import '../../css/mainheader.css';
import Interval from '../main/Interval';
import TextHeader from './TextHeader';

function Main(props) {



  return (
    <>
      <div id="main-header">

        <TextHeader allLevelStatus={props.allLevelStatus} selectedLevel={props.selectedLevel}/>
        <Interval />

      </div>
    </>
  )
}

export default Main;
